document.addEventListener("DOMContentLoaded", function () {
  const itemsPerPage = 12;
  const paginationContainer = document.getElementById("pagination-container");
  let currentPage = 1;

  // --- Elements for the product-dropdown enable/disable behavior ---
  const productsDropdownWrapper = document
    .querySelector('.dropdown-list[data-select="products"]')
    .closest('.custom-select');
  const productsSelectedDisplay = productsDropdownWrapper.querySelector('.selected');

  // FR dropdown has no single "all-products" item (one per group), so this may be null.
  const allProductsItem = productsDropdownWrapper.querySelector('li[data-value="all-products"]');
  const allProductsText = allProductsItem
    ? allProductsItem.querySelector('.option-title').innerText
    : 'Tous les Produits';

  // ------------------------------------------------------------------
  // FR LOCALIZATION
  // The page body uses French data-category values and French product
  // data-values, but the filter logic is keyed on canonical product ids.
  // These maps translate FR storefront strings -> filter keys so the
  // collection + product dropdowns match the rendered items again.
  // ------------------------------------------------------------------

  // Product dropdown data-value -> French item data-category
  const productToCategory = {
    'ultra-boost': 'coques-ultra-boost',
    'ultra-boost-lite': 'coques-ultra-boost-lite',
    'demi-boost': 'coques-demi-boost',
    'perfect-boost': 'coques-demi-boost-lite',
    'invisible-lift': 'coques-invisible-lift',
    'subtle-lift-inserts': 'coques-subtle-lift',
    'micro-lift-inserts': 'coques-micro-lift',
    'magic-padded-sticky-bra': 'soutien-gorge-adhesif-magique-rembourre',
    'sticky-bra': 'boomba-soutien-gorge-adhesif',
    'demi-sticky-bra': 'boomba-demi-soutien-gorge-adhesif',
    'invisibra': 'invisibra',
    'body-tape': 'ruban-de-corps',
    'reusable-body-tape': 'ruban-corps-reutilisable',
    'magic-breast-lift': 'cache-tetons-magic',
  };

  // Collection -> French data-category values it should reveal
  const inserts = [
    'coques-ultra-boost',
    'coques-ultra-boost-lite',
    'coques-demi-boost',
    'coques-demi-boost-lite',
    'coques-invisible-lift',
    'coques-subtle-lift',
    'coques-micro-lift',
  ];
  const bras = [
    'soutien-gorge-adhesif-magique-rembourre',
    'boomba-soutien-gorge-adhesif',
    'boomba-demi-soutien-gorge-adhesif',
    'invisibra',
  ];
  const tapes = [
    'ruban-de-corps',
    'ruban-corps-reutilisable',
    'cache-tetons-magic',
  ];

  function getVisibleItems() {
    return Array.from(document.querySelectorAll(".paginate:not(.hide)"));
  }

  function showPage(page) {
    currentPage = page;
    const visibleItems = getVisibleItems();
    const start = (page - 1) * itemsPerPage;
    const end = start + itemsPerPage;

    document.querySelectorAll(".paginate").forEach(item => {
      item.style.display = "none";
    });

    visibleItems.forEach((item, index) => {
      if (index >= start && index < end) {
        item.style.display = "block";
      }
    });

    renderPaginationControls(visibleItems.length);
  }

  function renderPaginationControls(totalVisible) {
    paginationContainer.innerHTML = "";
    const totalPages = Math.ceil(totalVisible / itemsPerPage);

    if (totalPages <= 1) return;

    const prevBtn = document.createElement("button");
    prevBtn.innerHTML = '<img src="https://cdn.shopify.com/s/files/1/0300/6637/6788/files/Component_1.png?v=1758516497">';
    prevBtn.disabled = currentPage === 1;
    prevBtn.addEventListener("click", () => showPage(currentPage - 1));
    paginationContainer.appendChild(prevBtn);

    const range = 1;
    let pages = [];

    for (let i = 1; i <= totalPages; i++) {
      if (i === 1 || i === totalPages || (i >= currentPage - range && i <= currentPage + range)) {
        pages.push(i);
      }
    }

    let lastPage;
    for (let i of pages) {
      if (lastPage) {
        if (i - lastPage === 2) {
          addPageButton(lastPage + 1);
        } else if (i - lastPage !== 1) {
          const ellipsis = document.createElement("span");
          ellipsis.innerText = "...";
          ellipsis.className = "pagination-dots";
          paginationContainer.appendChild(ellipsis);
        }
      }
      addPageButton(i);
      lastPage = i;
    }

    function addPageButton(i) {
      const btn = document.createElement("button");
      btn.innerText = i;
      btn.className = (i === currentPage) ? "active" : "";
      btn.addEventListener("click", () => showPage(i));
      paginationContainer.appendChild(btn);
    }

    const nextBtn = document.createElement("button");
    nextBtn.innerHTML = '<img src="https://cdn.shopify.com/s/files/1/0300/6637/6788/files/Vector.png?v=1758512062">';
    nextBtn.disabled = currentPage === totalPages;
    nextBtn.addEventListener("click", () => showPage(currentPage + 1));
    paginationContainer.appendChild(nextBtn);
  }

  function refreshPagination() {
    showPage(1);
  }

  // ------------------------------------
  // DROPDOWN FILTER LOGIC
  // ------------------------------------
  const selectedValues = {
    collections: null,
    products: null,
    cups: null,
  };

  const imageItem = document.querySelectorAll('.content-sizing-area__result-item');

  function resetCollection() {
    imageItem.forEach(item => {
      item.classList.remove('hide', 'selected');
    });
  }

  function resetProductDropdownToAll() {
    selectedValues.products = null;
    productsSelectedDisplay.innerHTML = `<span>${allProductsText}</span>`;
    productsDropdownWrapper.querySelectorAll('li').forEach(item => {
      item.classList.remove('active');
      item.querySelector('.radio-circle')?.classList.remove('active');
    });
    if (allProductsItem) {
      allProductsItem.classList.add('active');
      allProductsItem.querySelector('.radio-circle')?.classList.add('active');
    }
  }

  function toggleProductDropdownState(shouldDisable) {
    if (shouldDisable) {
      productsDropdownWrapper.classList.add('disabled');
      productsSelectedDisplay.style.pointerEvents = 'none';
      resetProductDropdownToAll();
    } else {
      productsDropdownWrapper.classList.remove('disabled');
      productsSelectedDisplay.style.pointerEvents = '';
    }
    applyFilters();
  }

  // Returns whether an item's French data-category matches the active
  // collection + product selection.
  function itemMatchesSelection(category, collections, products) {
    let show = true;

    if (collections === 'adhesive-inserts') show = inserts.includes(category);
    else if (collections === 'body-tapes') show = tapes.includes(category);
    else if (collections === 'adhesive-bras') show = bras.includes(category);

    if (show && products && collections !== 'all-collections') {
      const expectedCategory = productToCategory[products];
      if (expectedCategory) {
        show = category === expectedCategory;
      }
    }

    return show;
  }

  function updateAvailableCups() {
    const { collections, products } = selectedValues;
    const availableSizes = new Set();

    imageItem.forEach(item => {
      const category = item.getAttribute('data-category');
      const size = item.getAttribute('data-size');

      let show = itemMatchesSelection(category, collections, products);
      if (collections === 'all-collections' && products) show = true;

      if (show && size) availableSizes.add(size);
    });

    const cupDropdown = document.querySelector('.dropdown-list[data-select="cups"]');
    if (cupDropdown) {
      cupDropdown.querySelectorAll('li').forEach(li => {
        const cupVal = li.getAttribute('data-value');
        if (cupVal === 'all') {
          li.classList.remove('disabled');
          li.style.pointerEvents = "";
          li.style.opacity = "1";
          return;
        }
        if (!availableSizes.has(cupVal)) {
          li.classList.add('disabled');
          li.style.pointerEvents = "none";
          li.style.opacity = "0.5";
          li.style.color = "#d4d4d4";
        } else {
          li.classList.remove('disabled');
          li.style.pointerEvents = "";
          li.style.opacity = "1";
          li.style.color = "#222";
        }
      });
    }
  }

  function applyFilters() {
    resetCollection();
    const { collections, products, cups } = selectedValues;
    let hasMatch = false;
    updateAvailableCups();

    imageItem.forEach(item => {
      const category = item.getAttribute('data-category');
      const categorySize = item.getAttribute('data-size');

      let show = itemMatchesSelection(category, collections, products);
      if (show && cups && cups !== 'all') show = categorySize === cups;

      if (show) {
        item.classList.remove('hide');
        item.classList.add('selected');
        hasMatch = true;
      } else {
        item.classList.add('hide');
        item.classList.remove('selected');
      }
    });

    const noResultEl = document.querySelector('.no-results-message');
    if (noResultEl) noResultEl.style.display = hasMatch ? 'none' : 'block';
    refreshPagination();
  }

  document.querySelectorAll('.custom-select').forEach(selectBox => {
    const selected = selectBox.querySelector('.selected');
    const dropdownTypes = ['collections', 'products', 'cups'];

    selected.addEventListener('click', () => {
      if (selectBox.classList.contains('disabled')) return;
      document.querySelectorAll('.custom-select').forEach(otherBox => {
        if (otherBox !== selectBox) otherBox.classList.remove('open');
      });
      selectBox.classList.toggle('open');
    });

    dropdownTypes.forEach(type => {
      const dropdown = selectBox.querySelector(`.dropdown-list[data-select="${type}"]`);
      if (!dropdown) return;
      dropdown.querySelectorAll('li').forEach(item => {
        item.addEventListener('click', () => {
          if (item.classList.contains('disabled')) return;
          const value = item.getAttribute('data-value');
          const title = item.querySelector('.option-title')?.innerText || '';
          selectedValues[type] = value;

          if (type === 'collections') {
            const isAllCollections = value === 'all-collections';
            toggleProductDropdownState(isAllCollections);
            const productDropdown = document.querySelector('.dropdown-list[data-select="products"]');
            if (productDropdown) {
              const productItems = productDropdown.querySelectorAll('li');
              // FR product data-values per collection group.
              const insertsCat = ['all-inserts', 'ultra-boost', 'ultra-boost-lite', 'demi-boost', 'perfect-boost', 'invisible-lift', 'subtle-lift-inserts', 'micro-lift-inserts'];
              const brasCat = ['all-bras', 'magic-padded-sticky-bra', 'sticky-bra', 'demi-sticky-bra', 'invisibra'];
              const tapesCat = ['all-tapes', 'body-tape', 'reusable-body-tape', 'magic-breast-lift'];
              const allCat = [...insertsCat, ...brasCat, ...tapesCat];

              productItems.forEach(productItem => {
                productItem.classList.remove('hide');
                const pVal = productItem.getAttribute('data-value');
                let validList = (value === 'adhesive-inserts') ? insertsCat
                  : (value === 'adhesive-bras') ? brasCat
                  : (value === 'body-tapes') ? tapesCat
                  : allCat;
                if (validList.length && !validList.includes(pVal)) productItem.classList.add('hide');
              });
            }
          }

          selectBox.querySelectorAll('li').forEach(i => {
            i.classList.remove('active');
            i.querySelector('.radio-circle')?.classList.remove('active');
          });
          item.classList.add('active');
          item.querySelector('.radio-circle')?.classList.add('active');
          selected.innerHTML = `<span>${title}</span>`;
          applyFilters();
          selectBox.classList.remove('open');
        });
      });
    });
  });

  document.addEventListener('click', e => {
    document.querySelectorAll('.custom-select').forEach(box => {
      if (!box.contains(e.target)) box.classList.remove('open');
    });
  });

  document.querySelector('.reset-btn')?.addEventListener('click', () => {
    selectedValues.collections = null;
    selectedValues.products = null;
    selectedValues.cups = null;
    const allColl = document.querySelector('li[data-value="all-collections"]');
    if (allColl) selectedValues.collections = allColl.getAttribute('data-value');

    document.querySelectorAll('.custom-select').forEach(selectBox => {
      const selected = selectBox.querySelector('.selected');
      const defaultText = selected.getAttribute('data-placeholder') || 'Select';
      const selectType = selectBox.querySelector('.dropdown-list').getAttribute('data-select');
      selected.innerHTML = `<span>${defaultText}</span>`;
      selectBox.querySelectorAll('li').forEach(item => {
        item.classList.remove('active', 'hide');
        item.querySelector('.radio-circle')?.classList.remove('active');
      });
      let def;
      if (selectType === 'collections') def = selectBox.querySelector('li[data-value="all-collections"]');
      else if (selectType === 'products') def = selectBox.querySelector('li[data-value="all-products"]');
      else if (selectType === 'cups') def = selectBox.querySelector('li[data-value="all"]');
      if (def) {
        def.classList.add('active');
        def.querySelector('.radio-circle')?.classList.add('active');
      }
    });

    ['all-inserts', 'all-bras', 'all-tapes'].forEach(val =>
      document.querySelector(`li[data-value="${val}"]`)?.classList.add('hide')
    );
    toggleProductDropdownState(true);
    applyFilters();
  });

  // Initial Load
  showPage(1);
  updateAvailableCups();
  if (document.querySelector('li[data-value="all-collections"]')?.classList.contains('active')) {
    toggleProductDropdownState(true);
  }
});
